<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" />
    <vis-error size="md" v-else-if="error" with-default :state="state" />
    <div
      v-else
      class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start ba-m-auto"
    >
      <div
        class="identity__tabs ba-w-full ba-text-xl md:ba-text-2xl ba-mb-8 xs:ba-mb-10 ba-text-center"
      >
        <router-link
          :to="{ name: 'login', query: { state } }"
          class="tabs-item hover:ba-no-underline ba-mr-6"
        >
          <span>{{ $t("tabs.loginTab") }}</span>
        </router-link>
        <span class="tabs-item tabs-item--active">{{
          $t("tabs.registerTab")
        }}</span>
      </div>
      <p v-if="false" class="ba-text-center ba-text-sm ba-mb-5">
        {{ $t("register.registerPerson") }}
      </p>
      <form
        @submit.prevent="registerFormSubmit"
        class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-max-w-88 ba-relative"
      >
        <vis-form-messages
          v-if="formError"
          :form-error-message="$t('register.formError')"
          :form-field-messages="formFieldMessages"
        />
        <p
          v-if="formSuccess"
          class="success form-message ba-text-center ba-text-sm"
        >
          {{ $t("register.formSuccess") }}
        </p>
        <p
          v-if="formFieldsRequired"
          class="error form-message ba-text-center ba-text-sm"
        >
          {{ $t("register.formFieldsRequired") }}
        </p>
        <p
          v-if="formInvalidEmail"
          class="error form-message ba-text-center ba-text-sm"
        >
          {{ $t("register.formInvalidEmail") }}
        </p>
        <p
          v-if="formInvalidComparePassword"
          class="error form-message ba-text-center ba-text-sm"
        >
          {{ $t("register.formInvalidComparePassword") }}
        </p>
        <vis-form-input
          v-model="form.firstName"
          :disabled="formLoading"
          :label="$t('register.formFirstName')"
          type="text"
          icon="far fa-user"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.lastName"
          :disabled="formLoading"
          :label="$t('register.formLastName')"
          type="text"
          icon="far fa-user"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.email"
          :disabled="formLoading"
          :label="$t('register.formEmail')"
          icon="far fa-envelope"
          type="text"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.password"
          :disabled="formLoading"
          :label="$t('register.formPasswd')"
          type="password"
          icon="far fa-unlock-alt"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.repeatPassword"
          :disabled="formLoading"
          :label="$t('register.formRepeatPasswd')"
          type="password"
          icon="far fa-unlock-alt"
          autocomplete="off"
        />
        <vis-captcha
          v-if="showCaptcha && captchaEnabled"
          :result.sync="captchResult"
          :refresh.sync="refreshCaptcha"
        />
        <button
          type="submit"
          :disabled="formLoading || !personalData"
          class="btn ba-w-full btn--login ba-mt-2"
        >
          {{ $t("button.register") }}
        </button>
        <div
          class="input-wrap input-wrap--checkbox input-wrap--checkbox-agreement"
        >
          <input id="checkbox" type="checkbox" v-model="personalData" />
          <label for="checkbox" class="ba-flex ba-text-sm ba-leading-tight">
            <span class="ba-text-label">
              Согласие на обработку персональных данных в соответствии
              <a
                :href="publicUrl ? `${publicUrl}/content/1` : '#'"
                target="_blank"
                class="ba-text-info ba-underline"
              >
                с политикой конфиденциальности Портала НПА
              </a>
            </span>
          </label>
        </div>
      </form>
      <a
        v-if="false"
        target="_blank"
        href="https://domain/privacy/privacy-policy"
        class="ba-w-full ba-block ba-text-center ba-text-sm ba-underline hover:ba-no-underline"
        >{{ $t("privacyPolicy") }}</a
      >
      <a
        v-if="false"
        target="_blank"
        href="https://domain/privacy/user-agreement"
        class="ba-w-full ba-block ba-text-center ba-text-sm ba-underline hover:ba-no-underline"
        >{{ $t("userAgreement") }}</a
      >
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import VisCaptcha from "./vis-captcha";
import { registerMixin } from "@ba/visary-account-common-vue";
import formMessagesMixin from "@/mixins/form-messages-mixin";
import { fetchLaunchConfig } from "@/utils/app-setup";
import logger from "@/utils/logger";

export default {
  name: "vis-page-register",
  components: {
    VisLoginLayout,
    VisCaptcha
  },
  mixins: [registerMixin, formMessagesMixin],
  data() {
    return {
      captchaEnabled: false,
      publicUrl: null,
      personalData: false
    };
  },
  computed: {
    formMessages() {
      return {
        BadRequest: {
          password: {
            MinLength: this.passwordMinLength,
            MinCapitalLetters: this.passwordMinCapitalLetters,
            MinCursiveLetters: this.passwordMinCursiveLetters,
            MinDigits: this.passwordMinDigits,
            MinSpecialCharacters: this.passwordMinSpecialCharacters,
            MaxLength: this.passwordMaxLength
          }
        }
      };
    }
  },
  watch: {
    registerInfo() {
      if (!this.registerInfo?.canRegister) {
        this.$router.replace({ name: "login", query: { state: this.state } });
      }
    }
  },
  created() {
    this.getPublicUrl();
  },
  methods: {
    async getPublicUrl() {
      try {
        const launchConfig = await fetchLaunchConfig();
        this.publicUrl = launchConfig?.publicUrl;
      } catch (e) {
        logger.error(e);
      }
    }
  }
};
</script>
